import { Colors } from '@fourthwall/components';
import styled from 'styled-components';
export const Container = styled.div `
  flex: 1;
  padding: 20px;
  text-align: center;

  & + & {
    border-left: 1px solid ${Colors.GS400};
  }
`;
export const Title = styled.div `
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
`;
export const Subtitle = styled.div `
  font-size: 16px;
  line-height: 24px;
  color: ${Colors.GS600};
  margin-bottom: 16px;
`;
export const Input = styled.div `
  text-align: left;
  padding: 0 16px;

  & + & {
    margin-top: 16px;
  }
`;
